import { render, staticRenderFns } from "./register_success.vue?vue&type=template&id=b5ee04a2&scoped=true&"
import script from "./register_success.vue?vue&type=script&lang=js&"
export * from "./register_success.vue?vue&type=script&lang=js&"
import style0 from "./register_success.vue?vue&type=style&index=0&id=b5ee04a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ee04a2",
  null
  
)

export default component.exports